// Unpublished Work © 2024 Deere & Company.

interface Event {
    type: string;
    error?: {
        message: string;
    };
}

export function beforeSend(event: Event | undefined): boolean {
    if (event?.type === 'error' && event.error) {
        if (/ResizeObserver/.test(event.error.message)) {
            return false;
        }
    }

    // returning true will allow the event to be sent to datadog
    return true;
}
